
import Vue, { PropType } from "vue";
import { Auth } from "@/@core";
import { SmartSignFormService } from "@/@modules/fseg/services/SmartsignFormService";

export default Vue.extend({
  props: {
    hasToDeleteIban: {
      type: Boolean,
      default: false,
      required: false,
    },
    ibanForm: {
      type: Object as PropType<{
        iban: string;
        bic: string;
      }>,
      required: true,
    },
  },
  data() {
    return {
      dataObject: "",
      file: File,
      ibanCr: "",
      isCancellationWarning: false,
      loading: false,
      objectId: "",
      timestamp: "",
      xmlData: {
        bic: "",
        formCreationDateTime: "",
        iban: "",
        ssin: "",
      },
    };
  },
  mounted() {
    this.loadIbanCrXml();
  },
  computed: {
    subtitle(): string {
      return this.hasToDeleteIban ? this.$tc("fseg.ibanEdit.deleteRequest") : this.$tc("fseg.ibanEdit.updateRequest");
    },
    title(): string {
      return this.hasToDeleteIban && this.isCancellationWarning
        ? this.$tc("fseg.ibanEdit.warnCancel.deleteTitle")
        : this.isCancellationWarning
        ? this.$tc("fseg.ibanEdit.warnCancel.updateTitle")
        : this.hasToDeleteIban
        ? this.$tc("fseg.ibanEdit.deleteTitle")
        : this.$tc("fseg.ibanEdit.checkTitle");
    },
  },
  methods: {
    handleError() {
      this.$snackbar.show(
        "The file required for signing can't be generated, please try again later",
        10000,
        [{ label: "close", value: "" }],
        {
          error: true,
        }
      );
      console.error("error in IbanDataCheck on loadIbanCrXml");
      this.$modal.close(true);
    },
    getXml() {
      const fileName = "IbanCR.xml";
      const blob = new Blob([this.ibanCr], { type: "text/xml" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    parseXml(ibanCR: string) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(ibanCR, "text/xml");
      const dataArr = ["Bic", "FormCreationDateTime", "Iban", "Ssin"];
      dataArr.forEach(entry => {
        const element = doc.getElementsByTagName(entry);
        if (element.length) {
          const xmlDataKey = (entry.charAt(0).toLowerCase() + entry.slice(1)) as keyof {
            iban: string;
            ssin: string;
            bic: string;
            formCreationDateTime: string;
          };
          this.xmlData[xmlDataKey] = element[0].innerHTML;
        }
      });
    },
    warnOrCancel() {
      if (!this.isCancellationWarning) {
        this.isCancellationWarning = true;
      } else {
        this.$modal.close(false);
      }
    },
    async loadIbanCrXml() {
      this.loading = true;
      const resp = this.hasToDeleteIban
        ? await SmartSignFormService.getIbanCr()
        : await SmartSignFormService.getIbanCr(this.ibanForm.iban, this.ibanForm.bic);
      if (!resp) {
        this.handleError();
      } else {
        this.ibanCr = atob(resp.ibanCr);
        this.dataObject = resp.dataObject;
        this.objectId = resp.objectId;
        this.timestamp = resp.timestamp;
        this.parseXml(this.ibanCr.trim());
        this.loading = false;
      }
    },
    async submit() {
      if (this.isCancellationWarning) {
        this.isCancellationWarning = false;
      } else {
        Auth.forceRefreshToken();
        SmartSignFormService.submit(
          this.dataObject,
          { objectId: this.objectId, timestamp: this.timestamp },
          Auth.claims?.ssin
        );
      }
    },
  },
});
